import { DomainsWithPaging } from '@/types/api/Raw/domain';
import { query } from './api';

export const getDomainsWithPaging = async ({
  search,
  after,
  before,
  first,
  last,
}: {
  search?: string
  after?: string
  before?: string
  first?: number
  last?: number,
}): Promise<DomainsWithPaging> => {
  const getDomain = await query(
    `
    query GetDomainsWithPaging {
      domainsWithPaging(
        ${first ? `first: ${first}` : ''}
        ${last ? `last: ${last}` : ''}
        ${after ? `after: "${after}"` : ''}
        ${before ? `before: "${before}"` : ''}
        ${search ? `where:  {
          urlSuffix:  {
              contains: "${search}"
          }
        }`: ''}
    ){
      edges{
        cursor
        node{
          domainId
          price
          urlSuffix
          released
          logo
          __typename
        }
      }
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      }
    }
      `,
    {
      fetchPolicy: 'network-only'
    }
  );

  return getDomain?.data?.domainsWithPaging;
};
